import React, { useEffect, useState } from "react";
import {
  TextField, Button, Container, Typography, Select, MenuItem, Paper, Box, Snackbar, CircularProgress, Dialog, DialogTitle, DialogActions
} from "@mui/material";
import { createCashier } from "../../../../../services/Settings/Cashier";
import { getPrintersByBranch } from "../../../../../services/Settings/printers";
import { fetchAuthRoots } from "../../../../../services/apiService";

const CreateCashier = ({ onSuccess }) => {
  const [form, setForm] = useState({ name: "", printer_id: "", root_id: "" });
  const [branches, setBranches] = useState([]);
  const [printers, setPrinters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    const loadBranches = async () => {
      try {
        const branchesRes = await fetchAuthRoots();
        setBranches(branchesRes);
      } catch (err) {
        setMessage("❌ فشل في تحميل الفروع.");
      }
    };
    loadBranches();
  }, []);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    if (name === "root_id") {
      try {
        const printersRes = await getPrintersByBranch(value);
        setPrinters(printersRes);
      } catch (error) {
        setMessage("❌ فشل في تحميل الطابعات لهذا الفرع.");
        setPrinters([]);
      }
    }
  };

  const handleConfirm = async () => {
    setConfirmOpen(false);
    setLoading(true);
    try {
      await createCashier(form);
      setMessage(`✅ تم إنشاء الكاشير "${form.name}" بنجاح!`);
      setForm({ name: "", printer_id: "", root_id: "" });
      setPrinters([]);
      if (onSuccess) onSuccess();
    } catch (error) {
      setMessage(`❌ ${error.message}`);
    }
    setLoading(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setConfirmOpen(true);
  };

  return (
    <Container maxWidth="sm">
      <Paper sx={{ p: 4, mt: 4 }}>
        <Typography variant="h5" gutterBottom>🧾 إنشاء كاشير جديد</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="اسم الكاشير"
            name="name"
            value={form.name}
            onChange={handleChange}
            fullWidth
            required
            margin="normal"
          />

          <Select
            name="root_id"
            value={form.root_id}
            onChange={handleChange}
            displayEmpty
            fullWidth
            required
            margin="normal"
          >
            <MenuItem value="">اختر الفرع</MenuItem>
            {branches.map((branch) => (
              <MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>
            ))}
          </Select>

          <Select
            name="printer_id"
            value={form.printer_id}
            onChange={handleChange}
            displayEmpty
            fullWidth
            required
            margin="normal"
            disabled={!form.root_id}
          >
            <MenuItem value="">اختر الطابعة</MenuItem>
            {printers.map((printer) => (
              <MenuItem key={printer.id} value={printer.id}>{printer.name}</MenuItem>
            ))}
          </Select>

          <Box mt={3}>
            <Button type="submit" variant="contained" fullWidth disabled={loading}>
              {loading ? <CircularProgress size={24} /> : "إنشاء الكاشير"}
            </Button>
          </Box>
        </form>
      </Paper>

      <Snackbar
        open={!!message}
        autoHideDuration={4000}
        onClose={() => setMessage("")}
        message={message}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      />

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>
          هل تريد حفظ الكاشير "{form.name}"؟
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>إلغاء</Button>
          <Button onClick={handleConfirm} variant="contained" color="primary">
            تأكيد الحفظ
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default CreateCashier;
